import { render, staticRenderFns } from "./textList.vue?vue&type=template&id=73913ece&"
import script from "./textList.vue?vue&type=script&lang=js&"
export * from "./textList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports